webpackJsonp([173523045491671],{

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(35);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuggestPage = function SuggestPage() {
	  return _react2.default.createElement(
	    'div',
	    { style: { maxWidth: 1260, margin: '0 auto' } },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Suggest a growth tool | Find Growth Tools'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { basic: true },
	      _react2.default.createElement(
	        _semanticUiReact.Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Breadcrumb.Section,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', style: { color: '#dcddde' } },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle left' }),
	            'Home'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      {
	        style: {
	          fontSize: '3.25rem',
	          color: '#fff'
	        }
	      },
	      'Suggest a tool'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'div',
	      { style: { maxWidth: 960, margin: '0 auto', minHeight: '400px' } },
	      _react2.default.createElement(
	        'p',
	        { style: { fontSize: '1.25em', color: '#fff', textAlign: 'center' } },
	        'Know a great growth-related product that isn\'t on the site? Make a suggestion!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { basic: true, style: { textAlign: 'center' } },
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          { primary: true, size: 'huge', href: 'https://stirred.typeform.com/to/opaKD4', target: '_blank' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'external alternate' }),
	          ' Suggest a tool'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    )
	  );
	};
	
	exports.default = SuggestPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-suggest-js-7f486f4f533590e2c3e1.js